import { defineRouting } from "next-intl/routing";

/**
 * next-intl 4 routing config.
 *
 * Pathnames map INTERNAL file-system paths (under app/[locale]/*) to
 * EXTERNAL, locale-specific URLs. The internal pathname (the key) MUST
 * match the folder name in app/[locale]. Each value is either:
 *   - a string (same URL for all locales)
 *   - an object mapping locale -> external URL
 *
 * Example: file lives at app/[locale]/chi-sono/page.tsx, so the internal
 * pathname key is "/chi-sono". For en visitors the external URL becomes
 * /en/about; next-intl middleware rewrites /en/about to /en/chi-sono
 * internally without exposing the IT slug.
 */
export const routing = defineRouting({
  locales: ["it", "en"],
  defaultLocale: "it",
  localePrefix: "as-needed",
  localeDetection: false,
  pathnames: {
    "/": "/",
    "/chi-sono": { it: "/chi-sono", en: "/about" },
    "/servizi": { it: "/servizi", en: "/services" },
    "/servizi/[service]": {
      it: "/servizi/[service]",
      en: "/services/[service]",
    },
    "/strumenti/estensioni-chrome/argus": "/strumenti/estensioni-chrome/argus",
    "/strumenti/estensioni-chrome/argus/privacy":
      "/strumenti/estensioni-chrome/argus/privacy",
    "/metodo": { it: "/metodo", en: "/method" },
    "/mvp": { it: "/mvp", en: "/mvp" },
    "/progetti": { it: "/progetti", en: "/projects" },
    "/abbonamento": { it: "/abbonamento", en: "/subscription" },
    "/contatti": { it: "/contatti", en: "/contacts" },
    "/contatti/grazie": {
      it: "/contatti/grazie",
      en: "/contacts/thank-you",
    },
    "/profilo-tecnico-freelance": {
      it: "/profilo-tecnico-freelance",
      en: "/freelance-technical-profile",
    },
    "/profilo-tecnico-freelance/presentazione": {
      it: "/profilo-tecnico-freelance/presentazione",
      en: "/freelance-technical-profile/presentation",
    },
    "/privacy-policy": "/privacy-policy",
    "/cookie-policy": "/cookie-policy",
    "/termini-condizioni": {
      it: "/termini-condizioni",
      en: "/terms-conditions",
    },
  },
});

export type Locale = (typeof routing.locales)[number];
export type AppPathname = keyof typeof routing.pathnames;
